<template>
  <p>No Authorization</p>
</template>

<script>
export default {

}
</script>

<style>

</style>
